import { render, staticRenderFns } from "./fccAbaOpcao.vue?vue&type=template&id=5566e743"
import script from "./fccAbaOpcao.vue?vue&type=script&lang=js"
export * from "./fccAbaOpcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports